import script from "./RegisterEmployee.vue?vue&type=script&setup=true&lang=ts"
export * from "./RegisterEmployee.vue?vue&type=script&setup=true&lang=ts"

import "./RegisterEmployee.vue?vue&type=style&index=0&id=6191a10c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6191a10c"]])

export default __exports__